export const Religion_subject = 'Dorinis ugdymas (tikyba)';
export const Ethics_subject = 'Dorinis ugdymas (etika)';
export const LT_lang = 'Lietuvių kalba ir literatūra';
export const LT_spec_lang = 'Lietuvių gestų kalba';

//Baltarusių / hebrajų / lenkų / rusų / vokiečių
export const minority_lang = 'Tautinės mažumos gimtoji kalba ir literatūra';
export const foreign_first_lang = 'Užsienio kalba (pirmoji)';
export const foreign_second_lang = 'Užsienio kalba (antroji)';
export const VUS_subject = 'Visuomeninis ugdymas';
export const GMS_subject = 'Gamtos mokslai';
export const MAT_subject = 'Matematika';
export const BIO_subject = 'Biologija';
export const CHM_subject = 'Chemija';
export const FIZ_subject = 'Fizika';
export const TCH_subject = 'Technologijos';
export const HIS_subject = 'Istorija';
export const GEO_subject = 'Geografija';
export const ITS_subject = 'Informatika';
export const EIV_subject = 'Ekonomika ir verslumas';
export const PPA_subject = 'Pilietiškumo pagrindai';
export const ART_subject = 'Dailė';
export const MUZ_subject = 'Muzika';
export const THE_subject = 'Teatras';
export const DNC_subject = 'Šokis';
export const KUN_subject = 'Fizinis ugdymas';
export const GIG_subject = 'Gyvenimo įgūdžiai';
export const INZ_subject = 'Inžinerinės technologijos';
export const other_subject = 'Kita';

export const subjects = {
  Religion_subject,
  Ethics_subject,
  LT_lang,
  LT_spec_lang,
  minority_lang,
  foreign_first_lang,
  foreign_second_lang,
  VUS_subject,
  GMS_subject,
  MAT_subject,
  BIO_subject,
  CHM_subject,
  FIZ_subject,
  TCH_subject,
  HIS_subject,
  GEO_subject,
  ITS_subject,
  EIV_subject,
  PPA_subject,
  ART_subject,
  MUZ_subject,
  THE_subject,
  DNC_subject,
  KUN_subject,
  GIG_subject,
  INZ_subject,
  other_subject,
};

export const isInputRequired = (selectedSubject: string) =>
  [
    minority_lang,
    foreign_first_lang,
    foreign_second_lang,
    other_subject,
  ].includes(selectedSubject);
